import Vue from 'vue'
import store from '@/store'

/**
 * 检查用户是否拥有某个权限
 * @param {string} permission - 权限标识
 * @returns {boolean} - 是否拥有权限
 */
export function hasPermission(permission) {
  const buttons = store.state.permission.buttons
  
  // 如果权限不存在或未定义，默认为false
  if (!buttons || typeof buttons !== 'object') {
    return false
  }
  
  // 检查是否拥有该权限
  return !!buttons[permission]
}

/**
 * 权限指令
 * 用法：v-permission="'user:add'"
 * 作用：控制元素的显示与隐藏，无权限则不显示该元素
 */
Vue.directive('permission', {
  inserted: function(el, binding) {
    const permission = binding.value
    
    // 如果没有权限，隐藏元素
    if (!hasPermission(permission)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})

/**
 * 权限指令（禁用）
 * 用法：v-permission:disable="'user:add'"
 * 作用：控制元素的禁用状态，无权限则禁用该元素
 */
Vue.directive('permission:disable', {
  inserted: function(el, binding) {
    const permission = binding.value
    
    // 如果没有权限，禁用元素
    if (!hasPermission(permission)) {
      el.disabled = true
      el.classList.add('is-disabled')
    }
  }
})

/**
 * 导出权限验证方法，可在组件中使用
 */
export default {
  hasPermission
}